angular.module('natgeo').controller('Level2ConveyorScreen', ['$scope', '$element', 'ScreenFactory', 'screenManager', 'container', 'ColorizeFactory', 'UserProgress', 'CommonFunctions', 'ScreenView', 'SoundEngine',
function Level2ConveyorScreen($scope, element, ScreenFactory, manager, container, ColorizeFactory, UserProgress, CommonFunctions, ScreenView, SoundEngine)
{
	var screen = ScreenFactory( 'level2_conveyor', element );

	var HUNDRED_PERCENT = 100;
	var SEC_IN_MIN = 60;
	var MS_IN_SEC = 1000;

	screen.speedMultiplier = 0.4;
	screen.gameDimensions = {x: HUNDRED_PERCENT / 1024, y: HUNDRED_PERCENT / 672};
	screen.currentSelection = 'selectEffector';
	screen.beltToSelection = {
		'beltEffectors': 'selectEffector',
		'beltMotors': 'selectMotor',
		'beltSensors': 'selectSensor',
		'beltPower': 'selectPower',
		'beltProcessors': 'selectProcessor'
	};
	screen.currentBelt = 'beltEffectors';
	screen.currentBeltTraveling = false;
	screen.correctTotal = 10;
	screen.correct = 0;
	screen.maxTime = SEC_IN_MIN * 2; // 2 minutes
	screen.timeRemaining = screen.maxTime;
	screen.countdown = false;
	screen.timeStart = 0;
	screen.starting = false;
	screen.belts = [
		{
			name: 'beltMain',
			start: 	{x: -99, y: 553},
			end: 		{x: 403, y: 390},
			bottom: {x: 446, y: 500},
			scale: 1,
			origin: 'left bottom',
			rotate: 90,
			speed: 250 * screen.speedMultiplier, // px/s
			finalSpeed: 500 * screen.speedMultiplier, // px/s
			finalSpeedEnd: 0.75
		},
		{
			name: 'beltEffectors',
			start: 	{x: 447, y: 488},
			end: 		{x: 383, y: 371},
			bottom: {x: 378, y: 427},
			scale: 0.5,
			origin: 50,
			rotate: -45,
			speed: 400 * screen.speedMultiplier // px/s
		},
		{
			name: 'beltMotors',
			start: 	{x: 464, y: 499},
			end: 		{x: 496, y: 392},
			bottom: {x: 499, y: 461},
			scale: 0.5,
			origin: 50,
			rotate: 30,
			speed: 400 * screen.speedMultiplier // px/s
		},
		{
			name: 'beltSensors',
			start: 	{x: 464, y: 506},
			end: 		{x: 633, y: 424},
			bottom: {x: 630, y: 491},
			scale: 0.5,
			origin: 50,
			rotate: 90,
			speed: 400 * screen.speedMultiplier // px/s
		},
		{
			name: 'beltPower',
			start: 	{x: 459, y: 509},
			end: 		{x: 779, y: 456},
			bottom: {x: 775, y: 480},
			scale: 0.5,
			origin: 50,
			rotate: 115,
			speed: 400 * screen.speedMultiplier // px/s
		},
		{
			name: 'beltProcessors',
			start: 	{x: 516, y: 523},
			end: 		{x: 941, y: 491},
			bottom: {x: 932, y: 520},
			scale: 0.5,
			origin: 50,
			rotate: 135,
			speed: 400 * screen.speedMultiplier // px/s
		}
	];

	// Randomly returns part based on relative probabilities.
	screen.parts = (function() 
	{
		var map = {};

		screen._templates.children().each(function(i, e)
		{
			e = $( e );

			map[ e.data('named') ] = parseInt( e.data('prob') );
		});

		return new ProbabilityMap( map );
	})();

	// Build the Belt Animations
	screen.once('introBefore', function()
	{
		var calculator = anim8.calculator['2d'];

		angular.forEach( screen.belts, function(belt)
		{
			var d0 = calculator.distance( belt.start, belt.end );
			var d1 = calculator.distance( belt.end, belt.bottom );
			var dsum = d0 + d1;
			var dt = d0 / dsum;
			var keyframes = {};

			belt.distance = dsum;

			keyframes[ '0' ] = {
				center: calculator.mul( belt.start, screen.gameDimensions ),
				scale: belt.scale,
				opacity: 1,
				rotate: 0,
				zIndex: 3.1,
				origin: 50
			};
			keyframes[ dt ] = {
				center: calculator.mul( belt.end, screen.gameDimensions ),
				scale: belt.scale * 0.7,
				opacity: 1,
				rotate: 0,
				zIndex: 3.1,
				origin: 50
			};
			keyframes[ '1' ] = {
				center: calculator.mul( belt.bottom, screen.gameDimensions ),
				scale: belt.scale * 0.6,
				opacity: 0,
				rotate: belt.rotate,
				zIndex: 1,
				origin: belt.origin
			};

			anim8.save( belt.name, {
				keyframe: keyframes,
				units: {
					center: '%'
				}
			}, {
				easing: 'linear',
				duration: dsum / belt.speed * MS_IN_SEC
			});
		});
	});

	// Places the next part on the main conveyor belt.
	screen.nextPart = function()
	{
		var progress = anim8.clamp( Math.floor( (anim8.now() - screen.timeStart) / MS_IN_SEC ) / screen.maxTime, 0, 1 );
		var part = screen.sprite( screen.parts.random() ).clone();

		// Belt Speed increases over time
		var mainBelt = screen.belts[ 0 ];
		var beltProgress = progress < mainBelt.finalSpeedEnd ? progress : 1;
		var beltSpeed = (1 - beltProgress) * mainBelt.speed + beltProgress * mainBelt.finalSpeed;
		var beltDuration = mainBelt.distance / beltSpeed * MS_IN_SEC;

		part
			.addClass( 'hidden' )
			.appendTo( screen._conveyorTop )
			.scale( container.getScale() )
			.removeAttr( 'anim8' )
			.animators()
			.play( 'beltMain', {duration: beltDuration} )
			.once( 'update', function() 
			{
				// On the first application make it visible
				part.removeClass('hidden');
			})
			.once( 'finished', function() 
			{	
				// Cancel Signal?
				if ( screen.CANCEL ) 
				{
					screen.stopCountdown();
					return;
				}

				// Once it's done animating, place it on the next belt.
				screen.currentBeltTraveling = true;
				part
					.appendTo( screen._conveyorBottom )
					.animators()
					.play( screen.currentBelt )
					.applyInitialState()
					.once( 'finished', function() 
					{
						part.remove();
						screen.onPartFall( part );
						screen.currentBeltTraveling = false;
					})
				;
			})
		;
	};

	// Part has fallen down a hole
	screen.onPartFall = function(part)
	{
		// Cancel Signal?
		if ( screen.CANCEL )
		{
			screen.stopCountdown();
			return;
		}

		if ( screen.currentBelt === part.data('belt') )
		{
			screen.flash( 'good', 'fadeIn 0.5s', 'fadeOut ~1s 1s' );
			screen.correct++;
			screen.updateCorrect();

			if ( screen.correct === screen.correctTotal )
			{
				screen.stopCountdown();

				SoundEngine.stopAll();

				CommonFunctions.showHelp( screen._success, function()
				{
					SoundEngine.play( 'goal-achieved' );
				});
			}

			SoundEngine.play( 'conveyor-good' );
		}
		else
		{
			screen.flash( 'bad', 'fadeIn 0.25s', 'fadeOut ~1s 1.25s' );

			SoundEngine.play( 'conveyor-bad');
		}

		if ( screen.correct !== screen.correctTotal )
		{
			if ( screen.timeRemaining !== 0 )
			{
				screen.nextPart();
			}
			else if ( screen.timeRemaining === 0 )
			{
				SoundEngine.stopAll();

				CommonFunctions.showHelp( screen._fail );
			}
		}
	};

	// Starts the countdown timer
	screen.startCountdown = function()
	{
		if ( screen.countdown !== false )
		{
			return;
		}

		screen.timeStart = anim8.now();

		screen.countdown = setInterval( function()
		{
			var elapsed = anim8.now() - screen.timeStart;

			screen.timeRemaining = Math.max( 0, screen.maxTime - Math.floor( elapsed / MS_IN_SEC ) );
			
			if ( screen.timeRemaining === 0 )
			{
				screen.stopCountdown();
			}

			if ( screen.updateTimeRemaining() )
			{
				$scope.$apply();	
			}

		}, 900);
	};

	// Updates the timeRemaining text
	screen.updateTimeRemaining = function()
	{
		var minutes = Math.floor( screen.timeRemaining / SEC_IN_MIN );
		var seconds = (screen.timeRemaining % SEC_IN_MIN);

		var newRemaining = minutes + (seconds < 10 ? ':0' : ':' ) + seconds;
		var changed = newRemaining !== $scope.timeRemaining;

		$scope.timeRemaining = newRemaining;

		return changed;
	};

	// Stops the countdown time
	screen.stopCountdown = function()
	{
		if ( screen.countdown !== false )
		{
			clearInterval( screen.countdown );
			screen.countdown = false;
		}
	};

	// Update the correct UI
	screen.updateCorrect = function()
	{
		var sprite = screen.sprite( 'correct' + screen.correct );

		if ( sprite )
		{
			screen._corrects.children().addClass('hidden');

			sprite
				.removeClass( 'hidden' )
				.play( 'bounceIn 0.5s' )
				.applyInitialState()
			;
		}
	};

	// Reset the game
	screen.reset = function()
	{
		screen.CANCEL = false;
		screen.correct = 0;
		screen.updateCorrect();
		screen.timeRemaining = screen.maxTime;
		
		if ( !$scope.$$phase && screen.updateTimeRemaining() ) 
		{
			$scope.$apply();
		}

		// Reset Buttons
		screen._next.addClass( 'hidden' );

		// Remove Parts from Belts
		screen._conveyorBottom.empty();
		screen._conveyorTop.empty();
	};

	// When the screen first initializes, set the skew of the time remaining
	screen.once('introBefore', function()
	{
		screen._timeRemaining.setAttributes({
			skewY: 4
		});
	});

	// Reset the counts before the level start
	screen.on('introBefore', function()
	{
		screen._intro.removeClass('hidden');
		screen._fail.addClass('hidden');
		screen._success.addClass('hidden');

		screen.reset();
	});

	// Key Input
  screen.on('introBefore', function()
  {
    Shortcuts.down( { key: Shortcuts.keys.Left }, screen.nextBelt( -1 ) );
    Shortcuts.down( { key: Shortcuts.keys.Right }, screen.nextBelt( +1 ) );
  });
  screen.on('outroBegin', function()
  {
    Shortcuts.off();
  });
	screen.indexOfBelt = function(nm)
	{
		var index = -1;

		angular.forEach( screen.belts, function(belt, i)
		{
			if ( belt.name === nm )
			{
				index = i;
			}
		});
		
		return index;
	};
  screen.nextBelt = function(direction) 
  {
  	return function() 
  	{
  		var i = screen.indexOfBelt( screen.currentBelt ) + direction;

  		if ( i >= 1 && i < screen.belts.length )
  		{
  			$scope.selectBelt( screen.belts[ i ].name );
  		}
  	};
  };

	// The amount of time remaining
	$scope.timeRemaining = '2:00';

	// Play the game!
	$scope.play = function()
	{
		screen.reset();
		screen.startCountdown();
		screen.nextPart();
		screen.starting = false;

		SoundEngine.play( 'conveyor-belt', {loop:-1} );
	};

	// Try Again!
	$scope.tryAgain = function()
	{
		CommonFunctions.hideHelp( screen._fail, $scope.play );
	};

	// Replay the game!
	$scope.replay = function()
	{
		CommonFunctions.hideHelp( screen._success, $scope.play );
	};

	// Start the game!
	$scope.start = function()
	{
		if ( !screen.starting )
		{
			screen.starting = true;
			CommonFunctions.hideHelp( screen._intro, $scope.play );
		}
	};

	// Select the belt!
	$scope.selectBelt = function(belt)
	{
		var selection = screen.beltToSelection[ belt ];

		if ( selection !== screen.currentSelection && !screen.currentBeltTraveling && !screen.sprite( screen.currentSelection ).isAnimating() )
		{
			screen.outroduce( screen.currentSelection, 'fadeOut 0.2s' );
			screen.currentSelection = selection;
			screen.currentBelt = belt;
			screen.introduce( screen.currentSelection, 'fadeIn 0.2s' );	
		}
	};

	// Post Build
	$scope.next = function()
	{
		SoundEngine.stopAll();

		manager.transition('level2_post_build');	
	};
	
	// The previous screen is the plan screen
	$scope.prev = function()
	{
		manager.transition('level2_plan');
	};
	
}]);